export default __webpack_public_path__ + "static/media/educat.2d2f7eaa.png";